angular.module('TodoController', ['ngTable']).controller('TodoController', ['$scope', '$location', '$routeParams', '$http', 'Todo', '$filter', 'NgTableParams', '$modal',
    function ($scope, $location, $routeParams, $http, Todo, $filter, NgTableParams, $modal) {


    }
]);